@if (isBrowser) {
  <div>
    <p-dialog [(visible)]="display"
              [header]="title"
              [style]="{width: '25vw'}">
      {{description}}
    </p-dialog>
  </div>
}